export function extractApiError(err: unknown): { message: string; output: string[] } {
  const axiosErr = err as {
    message?: string;
    code?: string;
    response?: { status?: number; statusText?: string; data?: { detail?: unknown } };
  };

  const output: string[] = [];

  if (axiosErr.response?.status) {
    output.push(`HTTP ${axiosErr.response.status}${axiosErr.response.statusText ? ` ${axiosErr.response.statusText}` : ''}`);
    if (axiosErr.response.status === 404) {
      output.push('مسیر API روی سرور پیدا نشد — احتمالاً بک‌اند آپدیت نشده است.');
    }
  }

  const detail = axiosErr.response?.data?.detail;

  if (typeof detail === 'string') {
    return { message: detail, output };
  }

  if (Array.isArray(detail)) {
    const lines = detail.map((item) => {
      if (item && typeof item === 'object' && 'msg' in item) {
        return String((item as { msg?: string }).msg || JSON.stringify(item));
      }
      return JSON.stringify(item);
    });
    return { message: 'خطای اعتبارسنجی درخواست', output: [...output, ...lines] };
  }

  if (detail && typeof detail === 'object') {
    output.push(JSON.stringify(detail));
  }

  if (axiosErr.code === 'ECONNABORTED') {
    return { message: 'زمان درخواست تمام شد (timeout)', output };
  }

  if (axiosErr.message === 'Network Error') {
    return { message: 'خطای شبکه — اتصال به سرور برقرار نشد', output };
  }

  if (axiosErr.message) {
    return { message: axiosErr.message, output };
  }

  return { message: 'خطا در دیباگ CDR — پاسخی از سرور دریافت نشد', output };
}
